import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';

import { DataTableModule, CalendarModule, ChipsModule } from 'primeng/primeng';

import { SharedModule } from 'app/shared/shared.module';

import { SurveyComponent } from './survey.component';

import { AddSurveyConfigComponent } from './addsurveyconfig/add-surveyconfig.component';
import { AddSurveyTemplateComponent } from './addsurveytemplate/add-surveytemplate.component';

import { SurveyConfigListComponent } from './surveyconfiglist/surveyconfig-list.component';
import { SurveyQuestionListComponent } from 'app/admin/survey/surveyquestionlist/surveyquestion-list.component';
import { SurveyTemplateListComponent } from './surveytemplatelist/surveytemplate-list.component';

import { SurveyManagementService } from './survey-management.service';
import {SurveyResponseListComponent} from './response/survey-response-list.component';
import {SurveyQuestionComponent} from './surveyquestion/surveyquestion.component';

@NgModule({
    declarations: [
        SurveyComponent,
        SurveyConfigListComponent,
        SurveyTemplateListComponent,
        SurveyQuestionListComponent,
        AddSurveyConfigComponent,
        SurveyQuestionComponent,
        AddSurveyTemplateComponent,
        SurveyResponseListComponent
    ],
    imports: [
        SharedModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule.forRoot(),
        FlexLayoutModule,
        DataTableModule,
        CalendarModule,
        ChipsModule,
    ],
    providers: [
        SurveyManagementService
    ],
    entryComponents: [
        AddSurveyConfigComponent,
        SurveyQuestionComponent,
        AddSurveyTemplateComponent,
        SurveyResponseListComponent
    ]
})

/**
 * Main module for the survey management.
*/
export class SurveyModule { }



// WEBPACK FOOTER //
// ./src/app/admin/survey/survey.module.ts